module.exports = __webpack_public_path__ + "static/Tania_Combineanimals-274d40edc3a53fb4740237bc4c67da87.jpg";